import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["ariaLabel", "children"];
import { jsx } from 'react/jsx-runtime';
import * as Toast from '@radix-ui/react-toast';
import { Button } from '../../button/button.js';

var NotificationButton = function NotificationButton(props) {
  var ariaLabel = props.ariaLabel,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return jsx(Toast.Action, {
    altText: ariaLabel,
    asChild: true,
    children: jsx(Button, _objectSpread(_objectSpread({}, rest), {}, {
      variant: "outline",
      children: children
    }))
  });
};

NotificationButton.displayName = 'Notification.Button';
export { NotificationButton };